import { AsyncPipe, LowerCasePipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';
import { VerificationStatus } from '@shared/models';
import { DateFormatPipe, NotAvailablePipe, TeamMemberNamePipe } from '@shared/pipes';

@Component({
  selector: 'app-account-verification-history',
  standalone: true,
  templateUrl: './account-verification-history.component.html',
  styleUrls: ['./account-verification-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RktButtonDirective, AsyncPipe, LowerCasePipe, TitleCasePipe, NotAvailablePipe, DateFormatPipe, TeamMemberNamePipe],
})
export class AccountVerificationHistoryComponent {
  activeModal = inject(ActiveModal);

  historyItems?: VerificationStatus[];
}
